import ClosedTickets from './ClosedTickets';

export default ClosedTickets;
